// @ts-nocheck
import React, { useState } from "react";
import {
  TextField,
  Grid,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  IconButton,
} from "@material-ui/core";
import api from "../../api";
import { checkValidEmail } from "../../utils/validations";
import { useSnackbar } from "notistack";
import BasicDialogue from "./BasicDialogue";
import ClearIcon from "@material-ui/icons/Clear";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  select: {
    paddingLeft: 12,
  },
}));

const rolesList = [
  {
    name: "Service Provider",
    value: "provider",
  },
  {
    name: "Integrator",
    value: "reseller",
  },
];

export default function AddResellerModal({
  show,
  handleClose,
  getIntegratorsList,
  role,
}) {
  const [emailReseller, setEmailReseller] = useState("");
  const [userRole, setUserRole] = useState("");

  const classes = useStyles();

  const { enqueueSnackbar } = useSnackbar();

  const createReseller = () => {
    api
      .post("/public/v2/user", {
        email: emailReseller,
        role: role === "admin" ? userRole : "reseller",
      })
      .then(() => {
        getIntegratorsList();
        handleClearForm();
        enqueueSnackbar(
          "Success. New user have to confirm email address via clicking verification link in email",
          { variant: "success", autoHideDuration: 3000 }
        );
      });
  };

  const handleChangeRole = (event) => {
    setUserRole(event.target.value);
  };

  const handleClearForm = () => {
    setEmailReseller("");
    setUserRole("");
    handleClose();
  };

  const isCreatingDisabled = (email) => {
    if (checkValidEmail(email)) return true;
    return false;
  };

  const Content = (
    <Grid container spacing={2} direction="column">
      <Grid item xs>
        <TextField
          name="email"
          size="small"
          fullWidth
          label="E-Mail"
          variant="outlined"
          type="mail"
          value={emailReseller}
          onChange={(e) => setEmailReseller(e.target.value)}
          helperText={
            !checkValidEmail(emailReseller) &&
            emailReseller !== "" &&
            "Wrong login format"
          }
          error={!checkValidEmail(emailReseller) && emailReseller !== ""}
        />
      </Grid>
      {role === "admin" ? (
        <Grid item xs>
          <FormControl style={{ width: "100%" }}>
            <InputLabel
              id="demo-simple-select-label"
              style={{ zIndex: 1, paddingLeft: 12 }}
            >
              Role
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={userRole}
              onChange={handleChangeRole}
              classes={{ root: classes.select }}
              endAdornment={
                userRole !== "" && (
                  <Box mr="15px">
                    <IconButton
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setUserRole("");
                      }}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Box>
                )
              }
            >
              {rolesList.map((item) => (
                <MenuItem key={item.name} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      ) : (
        <Grid item xs>
          <TextField
            name="role"
            size="small"
            fullWidth
            label="Role"
            variant="outlined"
            value="Integrator"
            disabled
          />
        </Grid>
      )}
    </Grid>
  );

  const Action = (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => handleClearForm()}
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={createReseller}
        disabled={
          !isCreatingDisabled(emailReseller) ||
          (role === "admin" && !userRole.length)
        }
      >
        Add New User
      </Button>
    </>
  );

  return (
    <>
      <BasicDialogue
        show={show}
        handleClose={handleClose}
        title="Add New User"
        Content={Content}
        Action={Action}
      />
    </>
  );
}
